import { render, staticRenderFns } from "./UpdateFolder.vue?vue&type=template&id=2ab7f20c&scoped=true&"
import script from "./UpdateFolder.vue?vue&type=script&lang=js&"
export * from "./UpdateFolder.vue?vue&type=script&lang=js&"
import style0 from "./UpdateFolder.vue?vue&type=style&index=0&id=2ab7f20c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab7f20c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VSelect})
